import styled from "styled-components";

export const _styled = styled;
